// src/reducers/rootReducer.ts
import { combineReducers } from '@reduxjs/toolkit';
import userInfoReducer from './redux/slices/customerSlice';
import chargerReducer from './redux/slices/chargerSlice';
import powerReducer from './redux/slices/powerSlice';
import dashBoardReducer from './redux/slices/dashboardSlice';
import maintenanceReducer from './redux/slices/maintenanceSlice';
import reportReducer from './redux/slices/reportSlice';
import remoteV2Reducer from './redux/slices/remoteSlice';
import docsReducer from './redux/slices/docsSlice';
import lokiLoggingReducer from './redux/slices/lokiLoggingSlice';


// Combine your slices here
const rootReducer = combineReducers({
    userInfo: userInfoReducer,
    chargers: chargerReducer,
    power: powerReducer,
    dashboard: dashBoardReducer,
    maintenance: maintenanceReducer,
    report: reportReducer,
    remoteV2: remoteV2Reducer,
    docs: docsReducer,
    lokiLogging: lokiLoggingReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
